"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRIGGER_STATUS = exports.TRIGGER_EVENT = void 0;
var TRIGGER_EVENT;
(function (TRIGGER_EVENT) {
    TRIGGER_EVENT["FIELDPRO_CREATE_ITEM"] = "FIELDPRO_CREATE_ITEM";
    TRIGGER_EVENT["FIELDPRO_EDIT_ITEM"] = "FIELDPRO_EDIT_ITEM";
    TRIGGER_EVENT["FIELDPRO_CREATE_MOBILE_USER"] = "FIELDPRO_CREATE_MOBILE_USER";
    TRIGGER_EVENT["FIELDPRO_CREATE_ORDER"] = "FIELDPRO_CREATE_ORDER";
    TRIGGER_EVENT["FIELDPRO_EDIT_ORDER"] = "FIELDPRO_EDIT_ORDER";
    TRIGGER_EVENT["FIELDPRO_ACTIVITY_REPORT_FULLY_SYNCED"] = "FIELDPRO_ACTIVITY_REPORT_FULLY_SYNCED";
    TRIGGER_EVENT["WEBHOOK_EVENT"] = "WEBHOOK_EVENT";
})(TRIGGER_EVENT || (exports.TRIGGER_EVENT = TRIGGER_EVENT = {}));
var TRIGGER_STATUS;
(function (TRIGGER_STATUS) {
    TRIGGER_STATUS["PENDING"] = "PENDING";
    TRIGGER_STATUS["ONGOING"] = "ONGOING";
    TRIGGER_STATUS["FIRED"] = "FIRED";
    TRIGGER_STATUS["FAILURE"] = "FAILURE";
    TRIGGER_STATUS["CANCELLED"] = "CANCELLED";
    TRIGGER_STATUS["SKIPPED"] = "SKIPPED";
})(TRIGGER_STATUS || (exports.TRIGGER_STATUS = TRIGGER_STATUS = {}));
